export const canonicalHost = 'www.gamezop.com'

export const extendedCanonicalHosts = [
  canonicalHost,
  // 'dev.gamezop.com',
  // 'staging.gamezop.com',
  // 'staging1.gamezop.com',
  // 'staging2.gamezop.com',
  // 'staging3.gamezop.com',
  // 'dev1.gamezop.com',
  // 'dev2.gamezop.com',
  // 'dev3.gamezop.com',
]

export const canonicalHosts = [canonicalHost, 'dev.gamezop.com']

export type CanonicalHost = {
  isCanonical: boolean
  isExtendedCanonical: boolean
}
